<template>
  <div>
    <tool-bar :title="toolbarTitle"></tool-bar>
    <loading :loading="loading"></loading>
    <error-alert-item
      :error-alert-event="errorAlertEvent"
      :network-error="networkError"
      @resetErrorAlertEvent="errorAlertEvent=false">
    </error-alert-item>

    <refresh-item
      :show="showDigioScriptRefresh"
      @onRefresh="loadDigioScript"
    ></refresh-item>

    <refresh-item
      :show="showMandateConfigRefresh"
      @onRefresh="fetchEMandateConfig"
    ></refresh-item>

    <activity-redirect-item
      :loan-tasks="tasks"
      :current-loan-task="currentTaskName"
      :is-loan-task="true"
      :redirect-activity="redirectActivity">
    </activity-redirect-item>
  </div>
</template>
<script>
import ToolBar from "../../layout/ToolBar";
import loanScopeDataHolder from "../../../data/model/LoanScopeDataHolder";
import loanTaskActivityNavigator from "../../../utils/LoanTasksActivityNavigator";
import Loading from "../../layout/Loading";
import dataSource from "../../../data/DataSource";
import { MessageConstants } from "../../../utils/MessageConstantUtil";
import ActivityRedirectItem from "../../layout/ActivityRedirectItem";
import ErrorAlertItem from "../../layout/ErrorAlertItem";
import ActivityNavigator, { Activities } from "../../../utils/ActivityNavigator";
import AlertService from "../../core/alert/AlertService";
import { environment } from "../../../environments/environment";
import RefreshItem from "../../layout/RefreshItem";
import storageUtil from "../../../utils/StorageUtil";

const DIGIO = "DIGIO";

export default {
  name: "SignEnachActivity",
  components: { ActivityRedirectItem, ErrorAlertItem, Loading, ToolBar, RefreshItem },
  data: () => ({
    toolbarTitle: "Emi Payment Registration",
    loading: false,
    errorAlertEvent: false,
    networkError: {},
    showDigioScriptRefresh: false,
    showMandateConfigRefresh: false
  }),

  mounted() {
    this.loadDigioScript();
  },

  methods: {
    loadDigioScript() {
      const outerContext = this;
      this.showDigioScriptRefresh = false;
      this.loading = true;
      const recaptchaScript = document.createElement("script");
      recaptchaScript.setAttribute("src", environment.digioScriptUrl);
      recaptchaScript.setAttribute("type", "text/javascript");
      document.head.appendChild(recaptchaScript);
      recaptchaScript.onload = function () {
        outerContext.fetchEMandateConfig();
      };
      recaptchaScript.onerror = function () {
        outerContext.loading = false;
        outerContext.showDigioScriptRefresh = true;
      };
    },

    fetchEMandateConfig() {
      this.showMandateConfigRefresh = false;
      this.loading = true;
      dataSource.getMandateConfiguration({ loanId: loanScopeDataHolder.getLoanId() })
        .then(mandateConfigRes => {
          this.loading = false;
          if (mandateConfigRes.errorOccurred) {
            this.showMandateConfigRefresh = true;
            this.showError(mandateConfigRes.data);
          } else {
            const mandateConfig = mandateConfigRes.data;
            if (DIGIO !== mandateConfig.vendorName) {
              this.showError({ title: "No vendor is present." });
            } else {
              if (!mandateConfig.requestId || !mandateConfig.mobileOrEmail) {
                this.showError({ title: "Document id or phone number is empty." });
              } else {
                this.doEMandate(mandateConfig.requestId, mandateConfig.mobileOrEmail);
              }
            }
          }
        });
    },

    doEMandate(requestId, mobileOrEmail) {
      const self = this;
      const digioConfig = {
        environment: environment.digioEnvironment,
        callback: function (response) {
          if (response.hasOwnProperty("error_code")) {
            self.onFailure();
          } else {
            self.onSuccess();
          }
        },
        logo: "",
        theme: {
          primaryColor: "#AB3498",
          secondaryColor: "#000000"
        },
        is_iframe: true
      };
      // eslint-disable-next-line no-undef
      const digio = new Digio(digioConfig);
      digio.init();
      digio.submit(requestId, mobileOrEmail);
    },

    onSuccess() {
      this.getNextTask()
    },

    onFailure() {
      AlertService.showToast(MessageConstants.DOCUMENT_SIGNING_FAILED_MESSAGE);
      ActivityNavigator.navigateTo(Activities.LOAN_DETAILS);
    },

    getNextTask() {
      this.loading = true;
      loanTaskActivityNavigator.getNextTask(this.tasks)
        .then(res => {
          this.loading = false;
          if (res.errorOccurred) {
            this.showError(res.data);
          }
        });
    },

    showError(error) {
      this.loading = false;
      this.networkError = error;
      this.errorAlertEvent = true;
    }
  },

  computed: {
    redirectActivity() {
      return Activities.LOAN_DETAILS;
    },

    tasks() {
      return [Activities.ENACH, Activities.NACH];
    },

    currentTaskName() {
      if (loanScopeDataHolder.getCurrentLoanTask()
        && loanScopeDataHolder.getCurrentLoanTask().name) {
        return loanScopeDataHolder.getCurrentLoanTask().name;
      }
      return '';
    },
  }
}

</script>

<style scoped src="../../../assets/style/base.css"></style>
